<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';

defineProps({
  isUpdating: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['block']);

// Espelha ContactBlocking::BLOCK_MODES. Todo bloqueio silencia o contato do mesmo jeito; o que
// se escolhe aqui é o que varia entre eles.
const BLOCK_MODES = ['silenced', 'bot_only', 'discarded'];

const { t } = useI18n();

const dialogRef = ref(null);
const selectedMode = ref('silenced');

const open = () => {
  selectedMode.value = 'silenced';
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const handleSelect = mode => {
  selectedMode.value = mode;
};

const handleConfirm = () => emit('block', selectedMode.value);

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CONTACTS_LAYOUT.BLOCK_DIALOG.TITLE')"
    :description="t('CONTACTS_LAYOUT.BLOCK_DIALOG.DESCRIPTION')"
    :confirm-button-label="t('CONTACTS_LAYOUT.BLOCK_DIALOG.CONFIRM')"
    :is-loading="isUpdating"
    @confirm="handleConfirm"
  >
    <div class="flex flex-col gap-3">
      <RadioCard
        v-for="mode in BLOCK_MODES"
        :id="mode"
        :key="mode"
        :label="t(`CONTACTS_LAYOUT.BLOCK_DIALOG.MODES.${mode}.LABEL`)"
        :description="
          t(`CONTACTS_LAYOUT.BLOCK_DIALOG.MODES.${mode}.DESCRIPTION`)
        "
        :is-active="selectedMode === mode"
        @select="handleSelect"
      />
    </div>
  </Dialog>
</template>
